import { Box, Tooltip } from "@mui/material";
import { COLORS } from "../../ui/Theme";
import TextArea from "../../components/form/TextArea";
import { useState } from "react";
import { mutate } from "swr";
import { addTicket } from "../../lib/dashboard/actions";
import { useParams } from "react-router-dom";
import { Attachment, Send } from "@mui/icons-material";
import { toast } from "react-toastify";

const ReplyTicket = () => {
  const [text, setText] = useState("");
  const [appendix, setAppendix] = useState(null);
  const [isFileErr, setIsFileErr] = useState(false);

  const { ticketId } = useParams();

  const handleChangeFile = (e) => {
    const file = e.target.files[0];
    if (!file) setAppendix(null);

    //validations
    const allowedTypes = ["application/zip", "image/jpeg", "image/png"];
    const maxSize = 10 * 1024 * 1024;

    if (allowedTypes.includes(file?.type) && file?.size < maxSize) {
      setAppendix(file);
      setIsFileErr(false);
    } else {
      setIsFileErr(true);
      toast.error(`فقط فرمت‌های jpg , png و zip مجاز هستند. سایز فایل نباید بیشتر از ۱۰مگابایت باشد.
`);
    }
  };

  const handleReplyTicket = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("response", JSON.stringify({ text }));
    formData.append("appendix", appendix);

    const res = await addTicket(formData, `/support/ticket/${ticketId}`);
    if (res.status === 200) {
      mutate(`/support/ticket/${ticketId}`);
      setText("");
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleReplyTicket}
      sx={{
        display: "flex",
        gap: "10px",
        position: "absolute",
        bottom: 0,
        right: 0,
        width: "100%",
        padding: "15px",
        bgcolor: COLORS.WHITE,
      }}
    >
      {(text || appendix) && (
        <Tooltip title="ارسال">
          <button
            disabled={isFileErr}
            className="btn btn-softblue"
            style={{ width: "70px" }}
          >
            <Send />
          </button>
        </Tooltip>
      )}

      <TextArea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="پیام خود را بنویسید..."
      />

      <Tooltip title="انتخاب فایل">
        <label
          className={`btn ${isFileErr && "btn-softred"} ${
            appendix && "btn-softblue"
          }`}
          style={{ color: !isFileErr && COLORS.BLUE, width: "70px" }}
        >
          <Attachment />
          <input type="file" hidden onChange={handleChangeFile} />
        </label>
      </Tooltip>
    </Box>
  );
};

export default ReplyTicket;
